import { useEffect } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import './App.css';

const ROUTES = {
  '/privacidad': PrivacyPage,
  '/terminos': TermsPage,
};

function App() {
  const path = window.location.pathname.replace(/\/+$/, '') || '/';
  const Page = ROUTES[path] || HomePage;

  // The browser tries to jump to the URL hash before React renders the target section.
  useEffect(() => {
    const { hash } = window.location;
    if (hash) {
      document.getElementById(decodeURIComponent(hash.slice(1)))?.scrollIntoView();
    }
  }, []);

  return (
    <div className="app">
      <Header />
      <main id="main">
        <Page />
      </main>
      <Footer />
    </div>
  );
}

export default App;
